<template>
    <div class="worked_offsite pt-4">
        <employee-public-info  :hidebacknext="true"></employee-public-info>
        <div v-if="currentAssignments.length > 0" class="row m-3 border rounded p-3" >
            <div class="col-md-12">
              <!--  -->

                <div class="ibox-title dashboard_title company-form-box-title pl-0">
                    <h4 class="clearfix">
                        <span class="float-left">
                            <template v-if="roster == 1">Assigned Shift:</template>
                            <template v-else>Office Time:</template>
                        </span>
                        <span class="float-right"></span>
                    </h4>
                </div>
              <b-list-group>
                <b-list-group-item v-for="item in currentAssignments" :key="item.id" button :style="{ background: item.shift.color+'11',color: item.shift.color }">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex flex-row align-items-center">
                      <div>
                        <strong>{{ item.shift.name }}</strong>
                        <div v-if="item.shift" class="small">
                          {{ moment(item.shift.start_time, 'HH:mm:ss').format('hh:mm A') }} - {{ moment(item.shift.end_time, 'HH:mm:ss').format('hh:mm A') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <b-form @submit.stop.prevent="onSubmit" class="w-50">
                <div class="">
                  <b-form-group id="absent-group" label-for="absent" >
                      <b-form-checkbox id="absent" v-model="fdata.absent" name="absent" value="1" unchecked-value="0">Absent</b-form-checkbox>
                  </b-form-group>
                </div>

                <div v-if="fdata.absent == 0">
                  <b-form-group id="check_in-group" label="Check In" label-for="check_in" v-if="fdata.absent == false">
                    <b-form-timepicker :labelCloseButton="'Save'" id="check_in" name="check_in" v-model="fdata.check_in" v-validate="'required'" data-vv-as="Check In Time"
                     :state="validateState('check_in')" minutes-step="5" reset-button :show-seconds="false" locale="en-US" :hour12="true" aria-describedby="check_in-feedback"/>
                  </b-form-group>

                  <b-form-group id="check_out-group" label="Checkout" label-for="check_out"  v-if="fdata.absent == false">
                    <b-form-timepicker :labelCloseButton="'Save'" id="check_out" name="check_out" v-model="fdata.check_out" v-validate="'required'"
                       data-vv-as="Check In Time" :state="validateState('check_out')" minutes-step="5" reset-button :show-seconds="false" locale="en-US" :hour12="true" aria-describedby="check_out-feedback"/>
                  </b-form-group>
                </div>
                <b-button type="submit" variant="primary">Submit</b-button>
              </b-form>
            </div>
        </div>
      <div v-else class="text-center my-4">No shift allocated.</div>
    </div>
</template>
<script>

    import moment from "moment";

    export default{
        props: [ 'attendance_date', 'roster'],
        data(){
            return {
              currentAssignments:[],
              fdata: {check_in: null, check_out:null , absent:0 , attendance_date:''},
              assignments: [],
              selectedId: null,
            }
        },
        methods:{
          moment,
            select(id) {
              // this.selectedId = id;
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

          loadAssignmentData(date){
            if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
              return false;
            }
            axios.get(this.$api_url + '/leave-attendance/assignment/details', {
              params: {
                date: date
              }
            }).then((response) => {
              this.currentAssignments = response.data;
            }).catch(e => this.serverError(e));
          },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }
                    formData.append('attendance_date', this.attendance_date);

                    axios.post(this.$api_url+'/leave-attendance/attendance-set', formData).then(function (response)
                                {
                                    this.$bvToast.toast('Saved!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });
                                    setTimeout(()=> this.$emit('childToParent'), 1000);

                                }.bind(this))
                                .catch((error) =>
                                {
                                    this.serverError(error);
                                });
                });
            },
        },
      created() {
          this.loadAssignmentData(this.attendance_date);
      }
    }
</script>
